// extracted by mini-css-extract-plugin
export default {"navbar-menu":"NavBarMenu_navbar-menu__JOsQR"};